import * as io from 'io-ts';

const getOrderTypeIdsFromContext = (context: io.Context): number[] => {
    if (!Array.isArray(context)) return [];

    const configEntry = context.find((entry) => Array.isArray((entry.actual as any)?.orderTypeIds));

    return configEntry ? (configEntry.actual as OLO.Config.LocationDetailsPage).orderTypeIds : [];
};

export const defaultForEmptyOrderType: io.Type<-1> = new io.Type<-1>(
    'DefaultForEmptyOrderType',
    (u): u is -1 => u === -1,
    (input, context) => {
        if (input === -1) {
            const orderTypeIds = getOrderTypeIdsFromContext(context);
            if (orderTypeIds.length === 0) {
                return io.failure(input, context, 'Value -1 is only allowed when orderTypeIds is not empty');
            }

            return io.success(-1);
        }

        return io.failure(input, context, 'Value must be -1');
    },
    io.identity,
);
